import { apiFetch } from '../api.js';

export const getUserRightsAPI = (roleGUID) => {
  return apiFetch(`/UserRights/GetUserRights?roleGUID=${roleGUID}`);
};

export const getUserRightsMenuAPI = (roleGUID) => {
  return apiFetch(`/UserRights/GetMenus?roleGUID=${roleGUID}`);
};

export const saveUserRightsAPI = (payload) => {
  return apiFetch(`/UserRights/WriteUserRights`, {
    method: 'POST',
    body: JSON.stringify(payload)
  });
};
